<div class="form-horizontal" [formGroup]="harvestInstructions">

  <div class="form-group">
    <label class="col-sm-4 control-label">Embryo Rescue?
      <a tooltip="Setting to 'Yes' will initiate the conversation between Controlled Environments and
                        Crop Genome Engineering regarding resourcing and timing but does NOT constitute an
                        automatic approval of this work"
         placement="right"
         container="body">
        <span class="glyphicon glyphicon-info-sign"></span>
      </a>
    </label>
    <span class="col-sm-8">
      <ui-switch formControlName="embryoRescue" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
    </span>
  </div>

  <div *ngIf="minimumSeedsToReturn.enabled" class="form-group" [class.has-error]="minimumSeedsToReturn.invalid">
    <label class="col-sm-4 control-label">Minimum number of seeds to return</label>
    <span class="col-sm-8">
      <input type="number" class="form-control" formControlName="minimumSeedsToReturn" appIntegerValueAccessor />
      <div class="alert alert-danger" *ngIf="minimumSeedsToReturn.errors?.min">
        Minimum number of seeds to return must be at least {{ minimumSeedsToReturn.errors.min.min }}
      </div>
    </span>
  </div>
  <div class="form-group row">
    <label class="control-label col-sm-4">Advancement Preferences
      <a
         tooltip="This group of fields indicates the timing and workflow for pedigree advancements and SIID creation"
         placement="right"
         container="body"
         >
        <span class="glyphicon glyphicon-info-sign"></span>
      </a>
    </label>
    <div class="col-sm-8">
      <div class="form-group row">
        <label class="col-sm-3 control-label">For Advancement?
           <a tooltip="For Pollination & Mature Harvest Requests, if “For Advancement” is set to “No”, seed will be counted and discarded."
            placement="right" container="body">
            <span class="glyphicon glyphicon-info-sign"></span>
          </a>
        </label>
        <span class="col-sm-9">
          <ui-switch formControlName="standardHarvest" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
        </span>
      </div>
      <ng-container *ngIf="showHarvestFollowupOptions">
        <div class="form-group row">
          <label class="col-sm-3 control-label">Haploid Induction?
            <a
               tooltip="Setting this toggle to 'Yes' indicates that when the
                       plants from this request are harvested, the progeny seed will have a haploid pedigree"
               placement="right"
               container="body"
               >
              <span class="glyphicon glyphicon-info-sign"></span>
            </a>
          </label>
          <span class="col-sm-9">
            <ui-switch formControlName="haploidInduction" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
          </span>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 control-label">Many-to-One?
            <a
               tooltip="Many EUIDs of the same genotype combined into a single SIID"
               placement="right"
               container="body"
               >
              <span class="glyphicon glyphicon-info-sign"></span>
            </a>
          </label>
          <span class="col-sm-9">
            <ui-switch formControlName="manyToOne" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
          </span>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 control-label">Unique Pedigree?
            <a
               tooltip="Setting this toggle to 'Yes' indicates that each EUID advanced from this request will
                       generate a unique pedigree to distinguish it from other advancements that have the same parents"
               placement="right"
               container="body"
               >
              <span class="glyphicon glyphicon-info-sign"></span>
            </a>
          </label>
          <span class="col-sm-9">
            <ui-switch formControlName="uniquePedigree" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/harvest-instructions/harvest-instructions.component.html